import React from 'react';
import InfoTooltip from '../ui/InfoTooltip';
import EmailButtonDesignFields from './EmailButtonDesignFields';
import { defaultProductCardOptions } from '../../utils/emailButtonStyles';

export default function ProductCardEmailSettingsFields({ value, onChange }) {
  const v = { ...defaultProductCardOptions(), includeProductCard: false, ...value };
  const set = (patch) => onChange({ ...v, ...patch });

  const paymentDesign = {
    buttonLabel: v.paymentButtonLabel,
    buttonColor: v.paymentButtonBackgroundColor,
    buttonBorderColor: v.paymentButtonBorderColor,
    buttonTextColor: v.paymentButtonTextColor,
    buttonShape: v.paymentButtonShape,
  };

  return (
    <div className="space-y-3 rounded-lg border border-dashed border-border bg-muted/20 p-3">
      <label className="flex cursor-pointer items-start gap-2 text-sm">
        <input
          type="checkbox"
          checked={Boolean(v.includeProductCard)}
          onChange={(e) => set({ includeProductCard: e.target.checked })}
          className="mt-0.5 rounded border-input"
        />
        <span className="flex flex-wrap items-center gap-1 font-medium text-foreground">
          Ajouter la fiche produit de la campagne au mail
          <InfoTooltip text="La fiche est ajoutée en fin de message. En appel produit, c’est le produit choisi ; sinon le premier produit de la campagne. Le bouton d’achat reprend le style ci-dessous." />
        </span>
      </label>
      {v.includeProductCard ? (
        <>
          <label className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              checked={v.showImage}
              onChange={(e) => set({ showImage: e.target.checked })}
              className="rounded border-input"
            />
            Afficher la photo / logo du produit
          </label>
          <label className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              checked={v.showDescription}
              onChange={(e) => set({ showDescription: e.target.checked })}
              className="rounded border-input"
            />
            Afficher la description du produit
          </label>
          <EmailButtonDesignFields
            title="Bouton d'achat (paiement)"
            value={paymentDesign}
            onChange={(next) =>
              set({
                paymentButtonLabel: next.buttonLabel,
                paymentButtonBackgroundColor: next.buttonColor,
                paymentButtonBorderColor: next.buttonBorderColor,
                paymentButtonTextColor: next.buttonTextColor,
                paymentButtonShape: next.buttonShape,
              })
            }
            labelKey="buttonLabel"
            bgKey="buttonColor"
            borderKey="buttonBorderColor"
            textKey="buttonTextColor"
            shapeKey="buttonShape"
          />
        </>
      ) : null}
    </div>
  );
}
